import { FaSearch } from "react-icons/fa";
import PropTypes from "prop-types";
import styles from "./SearchInput.module.scss";
import Input from "../Input/Input";
import { useState,useCallback } from "react";
import _ from 'lodash';

const SearchInput = ({ onSearch, error, onBlur, onChange,oNdebouncedSearch, ...props }) => {
  const [query, setQuery] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const debouncedSearch = useCallback(
    _.debounce((value) => {
      oNdebouncedSearch(value)
      //console.log('Search triggered with value:', value); // Replace with your search API or action
    }, 500), // Adjust delay time (500ms)
    []
  );

  const handleSearch = (e) => {
    debouncedSearch(e.target.value)
    setQuery(e.target.value);
    if (typeof onChange === "function") {
      onChange(e.target.value);
      
    }
  };

  const handleIconClick = () => {
    if (typeof onSearch === "function") {
      onSearch(query);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && typeof onSearch === "function") {
      onSearch(query);
    }
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = (event) => {
    setIsFocused(false);
    if (typeof onBlur === "function") {
      onBlur(event);
    }
  };

  return (
    <div className={`${styles.search_container} ${error ? styles.error : ""}`}>
      <FaSearch className={`${styles.searchIcon}`} onClick={handleIconClick} />
      <Input
        {...props}
        value={query}
        onBlur={handleBlur}
        onFocus={handleFocus}
        onChange={handleSearch}
        onKeyPress={handleKeyPress}
        className={`${styles.inputField} ${isFocused && styles.focused} ${
          error && styles.inputError
        }`}
      />
    </div>
  );
};

SearchInput.propTypes = {
  onSearch: PropTypes.func,
  error: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
};

SearchInput.defaultProps = {
  error: false,
};

export default SearchInput;
